import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DateTimeFilterService } from './date-time-filter.service';
import moment from 'proxies/dayjs';
import { CommunicationService } from '../../services/communication.service';
import { Subscription } from 'rxjs'
import { UtilService } from '../../services/util.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { PreferenceService } from '../../shared/services/preference.service';

@Component({
    selector: 'date-time-filter',
    templateUrl: './date-time-filter.component.html',
    styleUrls: ['./date-time-filter.component.scss'],
    standalone: false
})
export class DateTimeFilterComponent implements OnInit, OnDestroy {
  @Input() showPickerInQuicker: boolean;
  @Input() showAll: boolean;
  @Input() showHideDetails: boolean = true;
  @Input() activeDate: any;
  @Input() fifteenDaySlot:boolean = false;
  @Input() maxDateValue: any;
  @Input() id: any = "123456";
  @Input() showCalender: boolean = false;
  @Input() nextAvailableSlotConfigValue: any
  @Input() public set startDateEnable(value: boolean) {
    if (value) {
      this.minDate = moment()
    }
  }
  @Input() public set endDateEnable(value: boolean) {
    if (value) {
      this.maxDate = moment()
    }
  }
  @Output() sendPickerResult = new EventEmitter<any>();
  @Output() emitMoreSlotValue = new EventEmitter<any>();
  @Output() emitCalendarSlot = new EventEmitter<any>();
  dates: Array<Object> = [];
  clickedDate: any;
  pickerExists: boolean;
  noOfDays: number;
  minDate: any;
  maxDate: any; //subscription_details:Subscription;
  value: any = ""; checkAccessPermission:boolean = false;
  days: any; subscription_date: Subscription;
  today: boolean = true;
  hasSelectedDate: any; hasMaxDate: any;
  
  locale = {
    "locale": { "format": "MM/DD/YYYY HH:mm:ss" }
  }
  subscription: Subscription;

  constructor(
    private service: DateTimeFilterService,
    private communicationService: CommunicationService,
    private utilService: UtilService,
    private roleService: RolePermissionService,
    private preferenceService: PreferenceService
  ) {
    this.subscription = this.communicationService.dropdownChangesEmitted$.subscribe(
      data => {
        if (data.reset == true) {
          this.dates = []
          this.setFilter()
        }
      }
    )

    this.subscription_date = this.communicationService.emittedDate$.subscribe(data => {
      if (data) {
        let final_date = { startDate: moment(data), endDate: moment(data).endOf('day') }
        this.onChange(final_date);
      }
    })
  }

  hideDetials(event:any){
    this.preferenceService._saveCommonVoiceDetailsConfig('hide_patient_details', event.target.checked, ()=>{
      window.location.reload();
    });
  }

  getPatientDetails(){
    return this.preferenceService.checkCommonConfigEnabled('hide_patient_details')?this.preferenceService.checkCommonConfigEnabled('hide_patient_details'): false;
  }

  checkPermission() {
    return this.roleService.checkAccessPermission('slot_info', 'appointment', 'appointment')
  }

  checkShowCalendarPermission() {
    return this.roleService.checkAccessPermission('show_calendar', 'diagnostic', 'appointment')
  }

  ngOnInit() {
    this.checkAccessPermission = this.roleService.checkAccessPermission("show_fifteen_days","appointment","appointment");
    if (this.showPickerInQuicker == true) {
      this.noOfDays = 7;
    } else if (this.showAll == true) {
      this.noOfDays = 5;
    }
    else {
      this.noOfDays = 7;
    }
    this.service.getActiveDateFromPicker().subscribe(date => {
      try {
        this.clickedDate = date;
        this.choose(this.clickedDate);
      } catch (err) { }
    });
    if (this.maxDateValue)
      this.hasMaxDate = this.utilService.toTimeZoneDate(this.maxDateValue)
    this.setFilter();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription_date?.unsubscribe();
  }

  setFilter() {
    let noOfDays = this.noOfDays;
    if (this.hasMaxDate) {
      noOfDays = this.hasMaxDate.diff(this.minDate, 'days') + 1;
    }
    for (let i = 0; i < this.noOfDays; i++) {
      let dateObj = {
        alias: (i == 0 ? 'Today' : moment().add(i, 'days').format('DD MMM')),
        day: moment().add(i, 'days').format('DD'),
        dayOfWeek: moment().add(i, 'days').format('ddd'),
        month: moment().add(i, 'days').format('MMM'),
        shortDate: moment().add(i, 'days').format('DD MMM YYYY'),
        date: moment().add(i, 'days').valueOf(),
        disable: i <= noOfDays ? false : true
      };
      this.dates.push(dateObj);
    }
    if (this.activeDate) {
      let shortDate = moment(this.activeDate).add(0, 'days').format('DD MMM YYYY');
      let date = this.dates.find(val => {
        return val['shortDate'] == shortDate
      })
      if (date)
        this.clickedDate = date
      else {
        let format = moment(this.activeDate).format('MM/DD/YYYY');
        this.value = format;
        this.getRangedate(noOfDays,this.activeDate);
        let date = this.getOutOfRangeDate(this.activeDate);
        this.clickedDate = date;
      }
    } else {
      this.clickedDate = this.dates[0];
    }
    this.choose(this.clickedDate);
  }

  getRangedate(noOfDays,date){
    this.dates = [];
    this.today = false;
    for (let i = 0; i < this.noOfDays; i++) {
      let dateObj = {
        alias: (moment(date).add(i, 'days').format('DD MMM')),
        day: moment(date).add(i, 'days').format('DD'),
        dayOfWeek: moment(date).add(i, 'days').format('ddd'),
        month: moment(date).add(i, 'days').format('MMM'),
        shortDate: moment(date).add(i, 'days').format('DD MMM YYYY'),
        date: moment(date).add(i, 'days').valueOf(),
        disable: i <= noOfDays ? false : true
      };
      this.dates.push(dateObj);
    }
  }

  getOutOfRangeDate(date) {
    let dateObj = {
      alias: (moment(date).add(0, 'days').format('DD MMM')),
      day: moment(date).add(0, 'days').format('DD'),
      dayOfWeek: moment(date).add(0, 'days').format('ddd'),
      month: moment(date).add(0, 'days').format('MMM'),
      shortDate: moment(date).add(0, 'days').format('DD MMM YYYY'),
      date: moment(date).add(0, 'days').valueOf(),
    };
    return dateObj
  }
  choose(date) {
    if (date && date.disable) return;
    if (date == 'All') {
      let date = {
        alias: 0, day: 0, dayOfWeek: 0, month: 0, shortDate: 0, date: 0
      }
      this.service.setQuikcDate(date);
      this.clickedDate = "All";
    } else {
      this.service.setQuikcDate(date);
      this.clickedDate = date;
    }
    this.hasSelectedDate = date
    this.sendPickerResult.emit(date)
  }


  getTimeInUTC(event) {
    var getDate = new Date(event);
    let dateObj = {
      alias: moment(event).format('DD MMM'),
      day: moment(event).format('DD'),
      dayOfWeek: moment(event).format('ddd'),
      month: moment(event).format('MMM'),
      shortDate: moment(event).format('DD MMM YYYY'),
      date: moment(event).valueOf(),
      startDate: new Date(getDate.getFullYear(), getDate.getMonth(), getDate.getDate(), 0, 0, 0, 0).getTime(),
      endDate: new Date(getDate.getFullYear(), getDate.getMonth(), getDate.getDate(), 24, 0, 0, 0).getTime(),
    };
    this.service.setQuikcDate(dateObj);
  }

  moreDate() {
    this.clickedDate = "More";
  }

  hasFifteenDays(){
    this.emitMoreSlotValue.next(true);
  }

  showCalenderDetails(){
    this.emitCalendarSlot.next(false);
  }

  onChange(event) {
    this.today = false;
    let date = event.startDate;
    let myMoment: any = this.utilService.toTimeZoneDate(moment(date));
    this.dates = [];
    for (let i = 0; i < this.noOfDays; i++) {
      let dateObj = {
        alias: moment(myMoment).add(i, 'days').format('DD MMM'),
        date: moment(myMoment).add(i, 'days').valueOf(),
        day: moment(myMoment).add(i, 'days').format('DD'),
        dayOfWeek: moment(myMoment).add(i, 'days').format('ddd'),
        month: moment(myMoment).add(i, 'days').format('MMM'),
        shortDate: moment(myMoment).add(i, 'days').format('DD MMM YYYY'),
      };
      if (this.hasMaxDate) {
        dateObj['disable'] = moment(myMoment).add(i, 'days').valueOf() <= moment(this.hasMaxDate).valueOf() ? false : true;
      }
      this.dates.push(dateObj);
    }
    this.clickedDate = this.dates[0];
    this.hasSelectedDate = this.dates[0];
    this.sendPickerResult.emit(this.dates[0]);
  }


}
